var map = {
	"./Bass_A.jpg": 6652,
	"./Bass_A_2.jpg": 1593,
	"./Bass_B.jpg": 3762,
	"./Bass_C.jpg": 1997,
	"./Bass_D.jpg": 8506,
	"./Bass_D_2.jpg": 4083,
	"./Bass_E.jpg": 140,
	"./Bass_E_2.jpg": 5890,
	"./Bass_F.jpg": 761,
	"./Bass_F_2.jpg": 5733,
	"./Bass_G.jpg": 3620,
	"./Bass_G_2.jpg": 5522,
	"./Mid_B.jpg": 764,
	"./Mid_B_2.jpg": 7941,
	"./Mid_C.jpg": 6243,
	"./Mid_C_2.jpg": 7554,
	"./Mid_D.jpg": 3579,
	"./Mid_D_2.jpg": 9980,
	"./Treble_A.jpg": 741,
	"./Treble_A_2.jpg": 21,
	"./Treble_B.jpg": 2513,
	"./Treble_B_2.jpg": 5909,
	"./Treble_C.jpg": 2553,
	"./Treble_D.jpg": 7542,
	"./Treble_E.jpg": 1909,
	"./Treble_E_2.jpg": 8930,
	"./Treble_F.jpg": 2694,
	"./Treble_F_2.jpg": 1240,
	"./Treble_G.jpg": 8955,
	"./Treble_G_2.jpg": 32
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2441;